<template>
  <div class="relative p-4 border rounded-10 border-slate-300 dark:border-zinc-700 dark:text-zinc-300" data-testid="item-analytics-tab-wrapper">
    <div class="flex flex-col gap-4">
      <AnalyticsHeader />
      <HorizontalDivider class="my-0" />
      <AnalyticsViews v-if="publicVisitsCount && groupStatsCount" />
      <AnalyticsShare v-else />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';

import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useViewerStatsStore } from '@/modules/viewer/store/useViewerStatsStore';

import HorizontalDivider from '@/storybook/utilities/HorizontalDivider.vue';
import AnalyticsHeader from './AnalyticsHeader.vue';
import AnalyticsShare from './AnalyticsShare.vue';
import AnalyticsViews from './AnalyticsViews.vue';

const statsStore = useViewerStatsStore();
const { id, publicVisitsCount } = storeToRefs(useViewerItemStore());
const { groupStatsCount } = storeToRefs(useViewerStatsStore());

onBeforeMount(() => {
  loadStats();
});

const loadStats = () => {
  if (id.value) {
    statsStore.loadStats(id.value);
  }
};
</script>
